<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Equipments
          </v-card-title>
          <v-card-text>
              <v-text-field label="Equipment Name" autofocus v-model="activeItem.equipment_name"></v-text-field>
              <v-text-field label="Equipment Type" autofocus v-model="activeItem.equipment_type"></v-text-field>
              <v-text-field label="Floor" autofocus v-model="activeItem.floor"></v-text-field>
              <facility-selector v-model="activeItem.facility_name"></facility-selector>
              <v-textarea label="Notes" v-model="activeItem.notes">
              </v-textarea>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Equipment')">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import FacilitySelector from '../FacilitySelector'
  import {putEquipment} from '../../helper'

  export default {
    components: {  FacilitySelector },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.equipment_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
          //this.initializeVar()
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          equipment_id: null,
          equipment_name: '',
          equipment_type: '',
          floor: '',
            notes: '',
          facility_name: '',
          meta: '',

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          equipment_id: null,
          equipment_name: '',
          equipment_type: '',
          floor: '',
            notes: '',
          facility_name: '',
          meta: '',

          }
          if(close) {
              this.dialog = false;
          }
      },
      addRecord (close) {
        putEquipment(
          {
            'equipment_id': this.activeItem.equipment_id,
            'equipment_name': this.activeItem.equipment_name,
            'floor': this.activeItem.floor,
            'equipment_type': this.activeItem.equipment_type,
            'facility_name': this.activeItem.facility_name,
            'notes': this.activeItem.notes,
            'meta': this.activeItem.meta,

          }

        )
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'EquipmentRecordDialog'
  }
</script>

<style scoped>

</style>
